import React, { useContext, useEffect, useState } from 'react';
import { Form, Input, DatePicker, Select, Radio, Space, Spin } from 'antd';
import ButtonLink from 'components/theme_components/ButtonLink';
import { CheckOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { AuthContext } from 'components/Auth/Auth';
import FormInput from 'components/FormInput';
import IBasket from 'icons/IBasket';
import GetLabel from 'DisplayFramework/components/GetLabel';
import InputCurrency from 'components/InputCurrency';
import ParListSelect from 'components/ParListSelect';
import { FormInstance } from 'antd/lib';
import { useQuery } from 'react-query';
import { OutstandigAmountByCtridAndEffectDate } from 'services/fincontract';
import moment from 'moment';
import CIPayerSelect from 'pages/ClientInvoice/CIDetail/components/CIPayerSelect';
import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';
import { isBeforeDate } from 'utils/utilsSFS';

type PaymentModalProps = {
  setVisible: (visible: boolean) => void;
  setmodalVisibleConfirmVisible: (visible: boolean) => void;
  mode: string;
  source: 'encours' | 'contract-deta<il' | 'demandes';
  dataInput: any;
  form: FormInstance
};

const PaymentModal: React.FC<PaymentModalProps> = ({
  setVisible,
  setmodalVisibleConfirmVisible,
  mode,
  source,
  dataInput,
  form
}) => {


  const { isInspect } = useContext(AuthContext);
  const showRadioButtons = source !== 'encours';
  const [modalVisibleDelet, setmodalVisibleDelet] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('dataInput', dataInput)
    form.setFieldsValue({
      ...dataInput,
      motif: "TOTALREIM",
      event: 'tabschedulepayment',
      targetStatus: "TOTAL",
      effectdate: moment()
    });
    getOutstandigAmount(moment().format('YYYY-MM-DD'))
  }, [mode, dataInput, form]);



  const getOutstandigAmount = (effectdate: string) => {

    setLoading(true);
    OutstandigAmountByCtridAndEffectDate({ ctrid: dataInput.ctrid, effectdate: effectdate }).then((res) => {
      setLoading(false)
      if (res.code === "200") {
        form.setFieldValue('reimbursedamount', res.data)
      }
    }).catch(() => {
      setLoading(false)
    })

  }

  const handleDelete = () => {
    console.log('Delete payment request');
    setVisible(false);
    setmodalVisibleDelet(false)
  };

  const onchange = (value: string) => {
    form.setFieldsValue({ paymentType: value });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      className="large-ant-radio-btn no-border-radius ut-wizard-form "
    >
      {showRadioButtons && (
        <FormInput name="motif" className="custom-radio-group " nolabel>
          <Radio.Group
            defaultValue="TOTALREIM"
            buttonStyle="solid"
            className="w-100"
            // onChange={(e) => onchange(e.target.value)}
            value="TOTALREIM"
          >
            <Radio.Button
              value="PARTREIM"
              className="text-center custom-radio-button"
              disabled
            >
              <GetLabel label='partialpay' />
            </Radio.Button>
            <Radio.Button
              value="TOTALREIM"
              className="text-center custom-radio-button"
            >
              {/* Montant total */}
              <GetLabel label='totalpayement' />
            </Radio.Button>
          </Radio.Group>
        </FormInput>
      )}

      <FormInput
        // label={
        //   mode === 'create'
        //     ? 'Date de prélèvement'
        //     : 'Date de changement de statut'
        // }
        name="effectdate"
        className="mb-4"
        extra="JJ/MM/AAAA"
        rules={[{ required: true }]}
      >
        <DatePicker
          format="DD/MM/YYYY"
          className="w-full no-border-radius"
          placeholder="JJ/MM/AAAA"
          required
          onChange={(e: any) =>
            getOutstandigAmount(moment(e).format('YYYY-MM-DD'))
          }
          disabledDate={(d) =>
            isBeforeDate(
              d,
              moment()
            )
          }
        />
      </FormInput>

      <Spin spinning={loading}>
        <FormInput name="reimbursedamount" className="mb-4" rules={[{ required: true }]}>
          <InputCurrency className="no-border-radius" disabled currcode={dataInput.currcode} />
        </FormInput>
      </Spin>

      <FormInput name="bkaccount" className="mb-4" rules={[{ required: true }]}>
        <BankAccountListSelect
          params={{
            tpid: dataInput?.tpidclient,
            allowedBktype: [
              'INOUT',
            ],
          }}
        />
      </FormInput>

      <FormInput
        name="reason"
        className="mb-4"
      >
        <ParListSelect className="no-border-radius" parcode="PAYMOTIF" />

      </FormInput>

      <FormInput name="comments" className="mb-6" >
        <Input.TextArea rows={6} className="no-border-radius" />
      </FormInput>

      <div className="d-flex justify-between align-center pt-4">
        <div>
          {mode === 'modify' && (
            <ButtonLink
              className="ut-reset-btn ut-btn-no-border no-box-shadow mr-4 btn-supp "
              comcode="Suppdemande"
              icon={<IBasket />}
              onClick={() => {
                !isInspect && setmodalVisibleDelet(true);
              }}

            />
          )}
        </div>
        {/* <Space>
          <ButtonLink
            comcode={mode === 'modify' ? 'Fermer' : 'Annuler'}
            onClick={() => setVisible(false)}
            className="btn-light"
          />
          <ButtonLink
            comcode="Valider"
            type="primary"
            onClick={handleSubmit}
            className="no-border-radius"
          />
        </Space> */}
      </div>
      <ConfirmModal
        className="modalConfirmOrCancel"
        visible={modalVisibleDelet}
        status="error"
        message="Etes vous sure de vouloir supprimer ces demandes ?"
        onConfirm={
          handleDelete
        }
        onCancel={() => {
          !isInspect && setmodalVisibleDelet(false);
        }}
        Confirmcomcode="valider"
        Cancelcomcode='close'
      />

    </Form>
  );
};

export default PaymentModal;
